<template>
    <div class="sidebar-share-box">
        <div class="sidebar-share__biao">
            <div class="sidebar-share__icon"><i class="icon iconfont icon-fenxiang"></i></div>
            <div v-clickReport="34272755" class="sidebar-share__text">分享好友</div>
        </div>
        <div class="sidebar-share__list">
            <div class="sidebar-share__mode">
                <div class="share-button-box">
                    <a href="javascript:;" class="share-icon weixin" title="分享到微信" @click.prevent="onGetWXCodeHandler">
                        <i class="icon iconfont icon-weixin"></i>
                    </a>
                    <a href="javascript:;" class="share-icon sina" title="分享到新浪微博" @click.prevent="shareWindow(`http://service.weibo.com/share/share.php?url=${url(2)}&title=${title()}&source=${url()}&sourceUrl=${url()}&content=${desc}`)">
                        <i class="icon iconfont icon-weibo"></i>
                    </a>
                    <a href="javascript:;" @click.prevent="shareWindow(`http://connect.qq.com/widget/shareqq/index.html?url=${url(2)}&title=${title()}&source=${description()}&desc=${desc}`)" class="share-icon qq" title="分享到QQ好友">
                        <i class="icon iconfont icon-QQ"></i>
                    </a>
                    <a href="javascript:;" @click.prevent="shareWindow(`http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url(2)}&title=${title()}&summary=${description()}&site=${url()}`)" class="share-icon qzone" title="分享到QQ空间">
                        <i class="icon iconfont icon-qqkongjian"></i>
                    </a>
                </div>
            </div>
        </div>
        <modal name="shareWX" width="340" height="auto">
            <div class="share-dialog">
                <div class="share-dialog__title">
                    分享到朋友圈<i class="icon iconfont icon-guanbi share-dialog__close" @click="$modal.hide('shareWX')"></i>
                </div>
                <div class="share-dialog__body">
                    <!-- <iframe :src="wxCodeUrl" width="260" height="260" marginwidth="20"></iframe> -->
                    <img :src="wxCodeUrl" alt="微信分享二维码">
                </div>
                <div class="share-dialog__footer">
                    <div>打开微信，点击底部的“发现”，</div>
                    <div>使用“扫一扫”即可将网页分享至朋友圈。</div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import config from '~/environment';

export default {
    name: 'DetailShare',
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            desc: '名师出高徒，向上有高途',
            wxCodeUrl: ''
        };
    },
    mounted() {
        this.wxCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${this.url(1)}`;
    },
    methods: {
        description() {
            try {
                if (document) {
                    return document.getElementsByName('description')[0].getAttribute('content');
                }
            }
            catch (err) {
                return '';
            }
        },
        url(type) {
            if (type === 1) {
                const routeSplit = window.location.href.split('/');
                // 环境
                let gotoUrl = `https:${config.env.mUrl}`;
                routeSplit.splice(0, 3);
                routeSplit.unshift(gotoUrl);
                gotoUrl = routeSplit.join('/');
                return gotoUrl;
            }
            return window.location.href;
        },
        title() {
            try {
                if (document) {
                    return document.title;
                }
            }
            catch (err) {
                return '高途素养';
            }
        },
        shareWindow(url) {
            try {
                // https://github.com/surmon-china/surmon.me/blob/master/components/layout/share.vue
                // http://vue-social-share.surge.sh/
                // https://github.com/slince/social-share.js/blob/master/src/js/providers/qq.js
                url = encodeURI(url);
                // 给打开的窗口命名
                const winName = '_blank';
                // screen.availWidth 获得屏幕宽度
                // screen.availHeight 获得屏幕高度
                // 居中的算法是：
                // 左右居中： (屏幕宽度 - 窗口宽度)/2
                // 上下居中： (屏幕高度 - 窗口高度)/2
                // 窗口宽度,需要设置
                const awidth = screen.availWidth / 6 * 2;
                // 窗口高度,需要设置
                const aheight = screen.availHeight / 5 * 2;
                // 窗口顶部位置,一般不需要改
                const atop = (screen.availHeight - aheight) / 2;
                // 窗口放中央,一般不需要改
                const aleft = (screen.availWidth - awidth) / 2;
                // 新窗口的参数
                const param0 = 'scrollbars=0,status=0,menubar=0,resizable=2,location=0';
                // 新窗口的左部位置，顶部位置，宽度，高度
                const params = `top=${atop},left=${aleft},width=${awidth},height=${aheight},${param0}`;
                // 打开新窗口
                const win = window.open(url, winName);
                // 新窗口获得焦点
                if (win.focus && typeof win.focus === 'function') {
                    win.focus();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        },
        onGetWXCodeHandler() {
            this.$modal.show('shareWX');
        }
    }
};
</script>

<style lang="less" scoped>
.sidebar-share__list {
    position: absolute;
    right: -88px;
    top: -31px;
    display: none;

    .share-button-box {
        position: relative;
        background-color: #fff;
        border-radius: 4px;
        border: solid 1px #ebebeb;
        padding: 20px 10px;

        .share-icon {
            display: block;
            width: 36px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 50%;

            &:not(:last-child) {
                margin-bottom: 14px;
            }

            i {
                font-size: 24px;
                color: #fff;
            }

            &.weixin {
                background-color: #07b906;
            }

            &.sina {
                background-color: #e53740;
            }

            &.qq {
                background-color: #3caae3;
            }

            &.qzone {
                background-color: #fbc452;
            }
        }
    }
}

.sidebar-share {
    &-box {
        float: right;
        position: relative;
        text-align: right;

        &:hover {
            .sidebar-share__list {
                display: block;
            }
        }
    }

    &__biao {
        position: relative;
        cursor: pointer;
    }

    &__icon {
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .icon {
            font-size: 24px;
            color: #a7b0b8;
        }
    }

    &__mode {
        position: relative;
        padding-left: 30px;
    }

    &__text {
        font-size: 14px;
        color: #a7b0b8;
    }
}

.share-dialog {
    text-align: center;

    &__title {
        position: relative;
        font-size: 20px;
        color: #32404b;
        padding: 30px 0 20px;
        text-align: center;
        margin: 0 20px;
        border-bottom: 1px dashed #ddd;
    }

    &__close {
        position: absolute;
        top: 15px;
        right: -5px;
        cursor: pointer;
    }

    &__body {
        margin: 10px 40px 0;
        background: #ebebeb url(~assets/img/emptyQrCode.png) no-repeat center center;

        img {
            display: inline-block;
            width: 260px;
            height: 260px;
        }
        height: 260px;
        overflow: hidden;
    }

    &__footer {
        margin: 10px 0 15px 40px;
        font-size: 12px;
        color: #666;
        text-align: left;

        div {
            line-height: 22px;
        }
    }
}
</style>
